<script setup lang="ts">
interface Entity {
  id: number;
  uuid?: string;
  name: string;
}

const props = defineProps<{ entities: Entity[] }>();
const entity = defineModel<string>({ required: false });
</script>

<template>
  <USelectMenu
    v-model="entity"
    :items="props.entities"
    value-key="uuid"
    label-key="name"
    data-cy="entity-select"
    size="xl"
    class="w-full bg-primary text-white"
  />
</template>
